<template>
  <!-- commented code refers to old speed maps that can run oppsosute directions -->
  <!-- Track runs to right -->
  <div v-if="tenant === 'do'">
    <div v-if="!runner.scratched && runner.speedmapPosition && stateToRight(race.meeting.track.state)" style="float: left" class="primaryColSM" :class="['position-' + runner.speedmapPosition]">
      <v-btn
        height="20"
        width="20"
        fab
        x-small
        color="white"
        class="caption font-weight-bold"
        style="margin-left:2px; float: left; margin-top: 1px"
      >{{runner.barrier}}</v-btn>
      <img
        class="mr-n7 mt-n1"
        style="float: right; padding-left: 10px;"
        :src="$silksUrl+'/'+gbsID+'_'+race.number+'_'+runner.tabNo+'_64x64.png'"
        alt="jockey silks"
        height="30"
      />
      <div v-if="bestOddsArray.length >= 1 && getRunnerFixedOddBookie(runner.tabNo)" :class="['logo-' + getRunnerFixedOddBookie(runner.tabNo), 'trackToRightRunner', 'ml-3', 'mt-1']" style="zoom:0.4"></div>
      <v-chip v-if="!runner.scratched && !isMobile" label x-small  style="margin-top: 3px;" class="ml-2 trackToRightRunner">{{getRunnerFixedOdd(runner.tabNo)}}</v-chip>
      <b class="trackToRightRunner" v-if="runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}}</b>
      <b class="trackToRightRunner" v-else-if="!runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}} (F/S)</b>
    </div>
    <!-- No speedmap position, track runs to right -->
    <div v-else-if="!runner.scratched && !runner.speedmapPosition && stateToRight(race.meeting.track.state)" style="float: left;" class="noSpeedMapPos primaryColSM">
      <v-btn
        height="20"
        width="20"
        fab
        x-small
        color="white"
        class="caption font-weight-bold"
        style="margin-left:2px; float: left; margin-top: 1px"
      >{{runner.barrier}}</v-btn>
      <img
        class="mr-n7 mt-n1"
        style="float: right; padding-left: 10px;"
        :src="$silksUrl+'/'+gbsID+'_'+race.number+'_'+runner.tabNo+'_64x64.png'"
        alt="jockey silks"
        height="30"
      />
      <div v-if="bestOddsArray.length >= 1 && getRunnerFixedOddBookie(runner.tabNo)" :class="['logo-' + getRunnerFixedOddBookie(runner.tabNo), 'trackToRightRunner', 'ml-3', 'mt-1']" style="zoom:0.4"></div>
      <v-chip v-if="!runner.scratched && !isMobile" label x-small  style="margin-top: 3px;" class="ml-2 trackToRightRunner">{{getRunnerFixedOdd(runner.tabNo)}}</v-chip>
      <b class="trackToRightRunner" v-if="runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}}</b>
      <b class="trackToRightRunner" v-else-if="!runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}} (F/S)</b>
    </div>
    <!-- Track runs to left -->
    <div v-else-if="!runner.scratched && runner.speedmapPosition && stateToLeft(race.meeting.track.state)" style="float: right" class="primaryColSM" :class="['position-' + runner.speedmapPosition]">
      <v-btn
        height="20"
        width="20"
        fab
        x-small
        color="white"
        class="caption font-weight-bold"
        style="margin-right:2px; float: right; margin-top: 1px"
      >{{runner.barrier}}</v-btn>
      <img
        class="ml-n7 mt-n1"
        style="float: left; padding-right: 10px;"
        :src="$silksUrl+'/'+gbsID+'_'+race.number+'_'+runner.tabNo+'_64x64.png'"
        alt="jockey silks"
        height="30"
      />
      <div v-if="bestOddsArray.length >= 1 && getRunnerFixedOddBookie(runner.tabNo)" :class="['logo-' + getRunnerFixedOddBookie(runner.tabNo), 'trackToLeftRunner', 'mr-3', 'mt-1']" style="zoom:0.4"></div>
      <v-chip v-if="!runner.scratched && !isMobile" label x-small  style="margin-top: 3px;" class="mr-2 trackToLeftRunner">{{getRunnerFixedOdd(runner.tabNo)}}</v-chip>
      <b class="trackToLeftRunner" v-if="runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}}</b>
      <b class="trackToLeftRunner" v-else-if="!runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}} (F/S)</b>
    </div>
    <!-- No speedmap position, track runs to left -->
    <div v-else-if="!runner.scratched && !runner.speedmapPosition && stateToLeft(race.meeting.track.state)" style="float: right;" class="noSpeedMapPos primaryColSM">
      <v-btn
        height="20"
        width="20"
        fab
        x-small
        color="white"
        class="caption font-weight-bold"
        style="margin-right: 2px; float: right; margin-top: 1px"
      >{{runner.barrier}}</v-btn>
      <img
        class="ml-n7 mt-n1"
        style="float: left; padding-right: 10px;"
        :src="$silksUrl+'/'+gbsID+'_'+race.number+'_'+runner.tabNo+'_64x64.png'"
        alt="jockey silks"
        height="30"
      />
      <div v-if="bestOddsArray.length >= 1 && getRunnerFixedOddBookie(runner.tabNo)" :class="['logo-' + getRunnerFixedOddBookie(runner.tabNo), 'trackToLeftRunner', 'mr-3', 'mt-1']" style="zoom:0.4"></div>
      <v-chip v-if="!runner.scratched && !isMobile" label x-small  style="margin-top: 3px;" class="mr-2 trackToLeftRunner">{{getRunnerFixedOdd(runner.tabNo)}}</v-chip>
      <b class="trackToLeftRunner" v-if="runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}}</b>
      <b class="trackToLeftRunner" v-else-if="!runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}} (F/S)</b>
    </div>
    <!-- Tracks other than AU with speedmap available -->
    <div v-else-if="!runner.scratched && runner.speedmapPosition" style="float: left" class="primaryColSM" :class="['position-' + runner.speedmapPosition]">
      <v-btn
        height="20"
        width="20"
        fab
        x-small
        color="white"
        class="caption font-weight-bold"
        style="margin-left:2px; float: left; margin-top: 1px"
      >{{runner.barrier}}</v-btn>
      <img
        class="mr-n7 mt-n1"
        style="float: right; padding-left: 10px;"
        :src="$silksUrl+'/'+gbsID+'_'+race.number+'_'+runner.tabNo+'_64x64.png'"
        alt="jockey silks"
        height="30"
      />
      <div v-if="bestOddsArray.length >= 1 && getRunnerFixedOddBookie(runner.tabNo)" :class="['logo-' + getRunnerFixedOddBookie(runner.tabNo), 'trackToRightRunner', 'ml-3', 'mt-1']" style="zoom:0.4"></div>
      <v-chip v-if="!runner.scratched && !isMobile" label x-small  style="margin-top: 3px;" class="mr-2 trackToRightRunner">{{getRunnerFixedOdd(runner.tabNo)}}</v-chip>
      <b class="trackToRightRunner" v-if="runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}}</b>
      <b class="trackToRightRunner" v-else-if="!runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}} (F/S)</b>
    </div>
    <!-- No speedmap position, tracks other than AU -->
    <div v-else-if="!runner.scratched && !runner.speedmapPosition" style="float: left;" class="noSpeedMapPos primaryColSM">
      <v-btn
        height="20"
        width="20"
        fab
        x-small
        color="white"
        class="caption font-weight-bold"
        style="margin-left:2px; float: left; margin-top: 1px"
      >{{runner.barrier}}</v-btn>
      <img
        class="mr-n7 mt-n1"
        style="float: right; padding-left: 10px;"
        :src="$silksUrl+'/'+gbsID+'_'+race.number+'_'+runner.tabNo+'_64x64.png'"
        alt="jockey silks"
        height="30"
      />
      <v-chip v-if="!runner.scratched && !isMobile" label x-small  style="margin-top: 3px;" class="ml-2 trackToRightRunner">{{getRunnerFixedOdd(runner.tabNo)}}</v-chip>
      <b class="trackToRightRunner" v-if="runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}}</b>
      <b class="trackToRightRunner" v-else-if="!runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}} (F/S)</b>
    </div>
  </div>
  <!-- Speedmap position -->
  <div v-else>
    <div v-if="!runner.scratched && runner.speedmapPosition" style="float: left" class="primaryColSM" :class="['position-' + runner.speedmapPosition]">
      <v-btn
        height="20"
        width="20"
        fab
        x-small
        color="white"
        class="caption font-weight-bold"
        style="margin-left:2px; float: left; margin-top: 1px"
      >{{runner.barrier}}</v-btn>
      <div class="mr-n7 mt-n1" style="float: right; padding-left: 10px;">
        <img
          :src="$silksUrl+'/'+gbsID+'_'+race.number+'_'+runner.tabNo+'_64x64.png'"
          alt="jockey silks"
          height="30"
        />
      </div>
      <v-chip v-if="!runner.scratched && !isMobile" label x-small  style="margin-top: 3px;" class="ml-2 trackToRightRunner">{{getRunnerFixedOdd(runner.tabNo)}}</v-chip>
      <b class="trackToRightRunner" v-if="runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}}</b>
      <b class="trackToRightRunner" v-else-if="!runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}} (F/S)</b>
    </div>
    <!-- No speedmap position -->
    <div v-else-if="!runner.scratched && !runner.speedmapPosition" style="float: left;" class="noSpeedMapPos primaryColSM">
      <v-btn
        height="20"
        width="20"
        fab
        x-small
        color="white"
        class="caption font-weight-bold"
        style="margin-left:2px; float: left; margin-top: 1px"
      >{{runner.barrier}}</v-btn>
      <img
        class="mr-n7 mt-n1"
        style="float: right; padding-left: 10px;"
        :src="$silksUrl+'/'+gbsID+'_'+race.number+'_'+runner.tabNo+'_64x64.png'"
        alt="jockey silks"
        height="30"
      />
      <v-chip v-if="!runner.scratched && !isMobile" label x-small  style="margin-top: 3px;" class="ml-2 trackToRightRunner">{{getRunnerFixedOdd(runner.tabNo)}}</v-chip>
      <b class="trackToRightRunner" v-if="runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}}</b>
      <b class="trackToRightRunner" v-else-if="!runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}} (F/S)</b>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'NewSpeedMap',
  props: {
    runner: Object,
    race: Object,
    tenant: String
  },
  computed: {
    ...mapState(['gbsID', 'bestOddsArray']),
    ...mapGetters(['isMobile'])
  },
  methods: {
    getRunnerFixedOdd (tabNo) {
      let fixedPrice = 0
      if (this.bestOddsArray.length >= 1) {
        this.bestOddsArray.forEach(b => {
          // eslint-disable-next-line eqeqeq
          if (tabNo == b.tabNo) {
            fixedPrice = b.price
          }
        })
      } else {
        this.race.competitors.forEach(b => {
          // eslint-disable-next-line eqeqeq
          if (tabNo == b.tabNo) {
            // eslint-disable-next-line eqeqeq
            const newPrices = b.prices.filter(b => b.type == 'WIN_FIXED_ODDS')
            const flucs = newPrices.map(a => a.price)
            fixedPrice = flucs[flucs.length - 1] || 0
          }
        })
      }
      return `$${fixedPrice.toFixed(2)}`
    },
    getRunnerFixedOddBookie (tabNo) {
      let bookie = 0
      this.bestOddsArray.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (tabNo == b.tabNo) {
          bookie = b.source
        }
      })
      return bookie
    },
    stateToRight (state) {
      switch (state) {
        case 'QLD':
          return true
        case 'NSW':
          return true
        case 'ACT':
          return true
      }
    },
    stateToLeft (state) {
      switch (state) {
        case 'VIC':
          return true
        case 'SA':
          return true
        case 'WA':
          return true
        case 'NT':
          return true
        case 'TAS':
          return true
      }
    }
  }
}
</script>

<style scoped>
.trackToRightRunner {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 60%;
  white-space: nowrap;
  float: right;
  font-size: 12px;
}
.trackToLeftRunner {
  text-overflow: ellipsis;
  max-width: 60%;
  overflow: hidden;
  white-space: nowrap;
  float: left;
  font-size: 12px;
}
.noSpeedMapPos {
  width: 35%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-REAR {
  width: 25%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-MID {
  width: 35%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-HANDY\/MID {
  width: 50%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-HANDY {
  width: 65%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-LEAD\/HANDY {
  width: 80%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-LEAD {
  width: 95%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.logoWidth {
  width: 55px;
  text-align: center;
}
.logo-WH {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 450px;
  background-size: 90px;
  margin: 0 auto;
}
/* RealBookie*/
.logo-RB3 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 45px 0px;
  background-size: 90px;
  margin: 0 auto;
}
/* BetDeluxe*/
.logo-BD2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 45px -180px;
  background-size: 90px;
  margin: 0 auto;
}
/* Dave Dwyer*/
.logo-DD {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 45px -585px;
  background-size: 90px;
  margin: 0 auto;
}
/* Tab Touch WA*/
.logo-OB {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 45px;
  background-size: 90px;
  margin: 0 auto;
}
/* Topsport*/
.logo-TS2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 360px;
  background-size: 90px;
  margin: 0 auto;
}
/* Sportsbet*/
.logo-SB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 540px;
  background-size: 90px;
  margin: 0 auto;
}
/* Betfair*/
.logo-BF {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -225px;
  background-size: 90px;
  margin: 0 auto;
}
/* Ladbrokes AU*/
.logo-LB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -495px;
  background-size: 90px;
  margin: 0 auto;
}
/* Topbetta with a twisit*/
.logo-TB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 315px;
  background-size: 90px;
  margin: 0 auto;
}
/* Official Price*/
.logo-OP {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -585px;
  background-size: 90px;
  margin: 0 auto;
}
/* BetVictor*/
.logo-BV {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -270px;
  background-size: 90px;
  margin: 0 auto;
}
/* SkyBet*/
.logo-SB6 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 585px;
  background-size: 90px;
  margin: 0 auto;
}
/* Coral*/
.logo-CB3 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -405px;
  background-size: 90px;
  margin: 0 auto;
}
/* Boyle Sports*/
.logo-BS3 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -360px;
  background-size: 90px;
  margin: 0 auto;
}
/* RaceBets*/
.logo-RB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 630px;
  background-size: 90px;
  margin: 0 auto;
}
/* BlueBet*/
.logo-BB3 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -315px;
  background-size: 90px;
  margin: 0 auto;
}
/* Unibet*/
.logo-UB {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 405px;
  background-size: 90px;
  margin: 0 auto;
}
/* Ladbrokes UK*/
.logo-LB2U {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 675px;
  background-size: 90px;
  margin: 0 auto;
}
/* Playup*/
.logo-CB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 45px -135px;
  background-size: 90px;
  margin: 0 auto;
}
/* Bet365*/
.logo-BT {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -90px;
  background-size: 90px;
  margin: 0 auto;
}
/* BetEasy*/
.logo-BE {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -180px;
  background-size: 90px;
  margin: 0 auto;
}
/* Sportsbetting*/
.logo-SB5 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 495px;
  background-size: 90px;
  margin: 0 auto;
}
/* GT*/
.logo-GT {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -450px;
  background-size: 90px;
  margin: 0 auto;
}
/* BestBookies*/
.logo-BB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -45px;
  background-size: 90px;
  margin: 0 auto;
}
/* BBet*/
.logo-BB4 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 0px;
  background-size: 90px;
  margin: 0 auto;
}
/* BetDogs*/
.logo-BD {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -135px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB NZ*/
.logo-NZ {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 90px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB Sportsbet (TAB QLD)*/
.logo-TS_Q {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 180px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB (TAB QLD)*/
.logo-Q {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 180px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB Sportsbet (TAB VIC)*/
.logo-TS_V {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 270px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB (TAB VIC)*/
.logo-V {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 270px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB NSW*/
.logo-N {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 225px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB NSW Sportsbet*/
.logo-TS_N {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 225px;
  background-size: 90px;
  margin: 0 auto;
}
/* Neds*/
.logo-ND {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -540px;
  background-size: 90px;
  margin: 0 auto;
}
</style>
